<template>
  <div class="f-shop-detail-reconciliationInfo tabs-item" id="reconciliationInfo">
    <div class="title">对账信息</div>
    <Search :renderData="renderData" :formData="form" @onSearch="onSearch" :labelWidth="100">
      <el-button slot="btn" @click="onExport" :loading="exportLoading">导出</el-button>
    </Search>
    <Table
      :tableThData="tableThData"
      :tableTrData="tableTrData"
      :loading="loading"
      :limit="limit"
      :offset="offset"
      :total="total"
      v-on:handleSizeChange="handleSizeChange"
      v-on:handleCurrentChange="handleCurrentChange"
    >
      <template v-for="(item, index) in tableThData" v-slot:[item.prop]="scope">
        <div v-if="item.prop != 'operation'" :key="index">
          <div v-if="item.prop == 'phone'">
            <span :key="tableKey">{{ scope.row.phone_show || scope.row.phone }}</span>
            <auth-button auth="user:phone:read">
              <el-button v-if="scope.row.phone" class="look-phone-btn"  type="text" @click="onLookPhone(scope.row, scope.scope.$index)">
                {{ scope.row.phone_show ? '隐藏' : '查看' }}
              </el-button>
            </auth-button>
          </div>
          <span v-else>{{ scope.row[item.prop] }}</span>
        </div>
      </template>
    </Table>
  </div>
</template>

<script>
import AuthButton from '@/components/AuthButton'
import aes from '@/common/aes.js'
import { downFile } from "@/utils";
import Search from "@/components/Search/index";
import Table from "@/components/Table/index";
import {api_getReconciliationCenterList, api_getTradeType, api_getPayType, api_postReconciliationExport} from '@/api/finance'
import { api_getUserPhone } from '@/api/common'
export default {
  name: "fsDetailReconciliationInfo",
  components: {
    AuthButton,
    Search,
    Table,
  },
  props: {},
  data() {
    return {
      exportLoading: false,
      renderData: [
        {
          label: "交易时间",
          placeholder: ['开始时间', '结束时间'],
          type: "date-range",
          key: "payTime",
          valueFormat: 'timestamp'
        },
        {
          label: "交易订单号",
          placeholder: "请选择交易订单号",
          type: "input",
          key: "paymentOrderId",
        },
        {
          label: "会员手机号",
          placeholder: "请输入会员手机号",
          type: "input",
          key: "phone",
        },
        {
          label: "交易类型",
          placeholder: "请选择交易类型",
          type: "select",
          key: "type",
          option: [],
        },
        {
          label: "支付方式",
          placeholder: "请选择支付方式",
          type: "select",
          key: "productCode",
          option: [],
          props: {
            label: 'name',
            value: 'code'
          }
        },
        {
          label: "订单来源",
          placeholder: "请选择订单来源",
          type: "select",
          multiple: false,
          key: "source",
          option: [{
            value: 'WechatMiniapp',
            label: '微信小程序'
          },{
            value: 'AlipayMiniapp',
            label: '支付宝小程序'
          }],
        }
      ],
      form: {},
      loading: false,
      tableKey: false,
      tableTrData: [],
      offset: 0,
      limit: 10,
      total: 0,
      tableThData: [],

    };
  },
  created() {
    this.getList()
    this.getTradeType() // 获取交易类型数据
    this.getPayType() // 获取支付类型数据
  },
  methods: {
    // 获取交易类型数据
    async getTradeType() {
      const res = await api_getTradeType()
      let index = this.renderData.findIndex(item => item.key == 'type')
      let newRes = res.map(item => {
        return { label: item, value: item, }
      })
      this.renderData[index].option = newRes || []
    },

    // 获取支付类型数据
    async getPayType() {
      const res = await api_getPayType({storeId: this.$route.query.id})
      let index = this.renderData.findIndex(item => item.key == 'productCode')
      this.renderData[index].option = res || []
    },

    // 获取表格列表数据
    async getList() {
      this.loading = true
      const params = {
        ...this.form,
        offset: this.offset,
        limit: this.limit,
        storeId: [this.$route.query.id]
      }
      params.startTime = this.form.payTime ? this.form.payTime[0] : '' // 支付时间-开始
      params.endTime = this.form.payTime ? this.form.payTime[1] : '' // 支付时间-结束
      delete params.payTime
      try {
        const res = await api_getReconciliationCenterList(params)
        console.log('对账中心res: ', res);
        this.tableThData = res.columnList.map((item) => {
          return {
            prop: item.valueKey,
            label: item.displayName,
            minWidth: 150
          }
        })
        this.tableTrData = res.pageResult.list || []
        this.total = res.pageResult.count
        this.loading = false
      } catch(err) {
        console.log('err: ', err);
        this.loading = false
      }
    },

    // 导出
    async onExport() {
      this.exportLoading = true
      const params = {
        ...this.form,
        productCode: this.form.productCode ? [this.form.productCode] : [],
        storeId: [this.$route.query.id]
      }
      if (this.form.payTime && this.form.payTime[0]) {
        params.startTime = this.form.payTime[0] // 支付时间-开始
      }
      if (this.form.payTime && this.form.payTime[1]) {
        params.endTime = this.form.payTime[1] // 支付时间-结束
      }
      delete params.payTime
      let res = await api_postReconciliationExport(params)
      downFile(res)
      this.exportLoading = false
    },

    // 点击查看手机号
    async onLookPhone(row, index) {
      if (row.phone_show) {
        delete this.tableTrData[index].phone_show
      } else {
        const {phone} = await api_getUserPhone({id: row.userId})
        this.tableTrData[index].phone_show = aes.decrypt(phone)
      }
      this.tableKey = !this.tableKey
    },

    onSearch(form) {
      this.form = form
      this.offset = 0
      this.getList()
    },
    handleSizeChange(limit) {
      this.limit = limit
      this.getList()
    },

    handleCurrentChange(offset) {
      this.offset = offset
      this.getList()
    }
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.f-shop-detail-reconciliationInfo {
  padding: 0 20px;
  padding-top: 20px;
  background-color: #fff;
  margin-bottom: 20px;
  border-radius: 4px;

  .title {
    margin: 0;
    margin-bottom: 30px;
    margin-left: 20px;
    height: 25px;
    line-height: 25px;
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    position: relative;

    &::before {
      position: absolute;
      top: 0;
      left: -15px;
      content: '';
      width: 5px;
      height: 25px;
      border-radius: 2px;
      background: #05C8AF;
    }
  }

  .el-button {
    min-width: 80px !important;
  }

  .look-phone-btn {
    font-size: 10px;
    color: #3775FF;
    margin-left: 5px;
  }
}
</style>
